import React, { useState } from 'react'
import { AddRecord } from '../../layouts/AddRecord';
import { InputField } from '../../layouts/FormFields';
import axios from 'axios';
import { app } from '../../config';
import getHeaders from '../../utils/authHeaders';
import { message } from 'antd';
import { useNavigate } from 'react-router-dom';


export const AddFacialPackage = () => {
  const [loading, setLoading] = useState(false);

   const [uploadObj, setUploadObj] = useState({});
  const [addUserResp, setAddUserResp] = useState({});
  let [show, setShow] = useState(false);
  let navigate = useNavigate();

  const onFinish = (values) => {
       console.log("success",values)
       setUploadObj(values);
       setShow(true);
       // return;
     };
     const onFinishFailed = (errorInfo) => {
       console.log('Failed:', errorInfo);
     };


  const user = JSON.parse(localStorage.getItem('user'));

  
  
  const uploadData = async (uploadObj) => {
    console.log(uploadObj);
    // let userId = user?.result.data.user.userId;
    // uploadObj.userId = userId;
    setLoading(true);

    try {
      console.log("Uploading", uploadObj);
      //  return
      const res = await axios.post(`${app.URL}/api/v1/admin/facialpackages/create`, uploadObj, { headers: getHeaders() });
      console.log(res);

      if (res.data.result.success) {
        setAddUserResp(res.data.result);
        message.success(res.data.result.msg);
        setTimeout(() => {
          navigate('/facialpackages/listing');
        }, 1000);
      } else if (!res.data.result.success) {
        message.warning(res.data.result.msg);
      }
    } catch (err) {
      setLoading(false);
      setShow(false);

      console.log(err);
      if (err) console.log(err.response.data.message);
      else return;
    }
  };

    const submitData = () => {
      console.log('calling: ', uploadObj);

      if (Object.keys(uploadObj).length > 0) {
        uploadData(uploadObj);
      }
    };
  

  function goBack() {
    navigate('/facialpackages/listing', { replace: true });
  }
  console.log(uploadObj);
  const handleClose = () => setShow(false);
  
  return (
    // <p>fsdf</p>
    <AddRecord
      pageTitle='Add Vital Package'
      loading={loading}
      onFinish={onFinish}
      addUserResp={addUserResp}
      addMessage='Are you sure you want to vital package?'
      onFinishFailed={onFinishFailed}
      initialValues={{
        remember: true,
        ['isActive']: true,
      }}
      inputs={[
        <div className='col-lg-8'>
          <div className='row'>
            <InputField
              col='col-md-6 col-12'
              name='name'
              label='PackageName'
              rules={[
                {
                  required: true,
                  message: 'Enter PackageName',
                },
              ]}
              placeholder='Enter PackageName'
              required={true}
            />
            <InputField
              col='col-md-6 col-12'
              name='scans'
              label='Scans'
              rules={[
                {
                  required: true,
                  message: 'Enter Scans',
                },
              ]}
              placeholder='Enter Scans'
              required={true}
            />
            <InputField
              col='col-md-6 col-12'
              name='validity'
              label='Validity'
              rules={[
                {
                  required: true,
                  message: 'Enter Validity',
                },
              ]}
              placeholder='Enter Validity'
              required={true}
            />
            <InputField
              col='col-md-6 col-12'
              name='pricing'
              label='Pricing'
              rules={[
                {
                  required: true,
                  message: 'Enter Pricing',
                },
              ]}
              placeholder='Enter Pricing'
              required={true}
            />
          </div>
        </div>,
      ]}
      upload={false}
      submitData={submitData}
      switchBtn={true}
      goBack={goBack}
      handleClose={handleClose}
      show={show}
    />
  );
}
